import { useT } from "@/i18n";
export const Logo = ({ light = false, size = 30 }) => {
  const { t } = useT();
  const c = light ? "#F4E9D8" : "#0F4C5C";
  return (
    <span className="inline-flex items-center gap-2" data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden>
        <circle cx="20" cy="11" r="7.5" stroke={c} strokeWidth="3" />
        <circle cx="20" cy="11" r="2.2" fill="#E36414" />
        <path d="M20 18.5 L26 30 L20 38 L14 30 Z" fill={c} />
        <line x1="20" y1="25" x2="20" y2="35" stroke={light ? "#0F4C5C" : "#F4E9D8"} strokeWidth="1.6" />
        <circle cx="20" cy="27.5" r="1.4" fill={light ? "#0F4C5C" : "#F4E9D8"} />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="font-display text-xl font-semibold" style={{ color: c }}>HostScribe</span>
        <span className="text-[9px] tracking-[0.18em] uppercase mt-0.5" style={{ color: light ? "#F4E9D8" : "#E36414", opacity: .85 }} data-testid="brand-endorsement">{t("by KINGBORNSYSTEM")}</span>
      </span>
    </span>
  );
};
